<style>
.link.primary {
  background-color: "transparent";
  border-color: var(--primary);
  color: var(--primary);
}

.link.black {
  background-color: "transparent";
  border-color: "transparent";
  color: black;
}
</style>

<script>
import Icon from "@shared/components/Icon.svelte"

//export let label = "Download"
export let links = []
export let className = ""
export let icon = undefined
export let color = "black"

$: black = color === "black"
$: primary = color === "primary"
</script>

{#each links as link}
  <a
    href="{link.url}"
    target="_blank"
    class="link block {`hover:underline ${className}`}"
    class:black="{black}"
    class:primary="{primary}"
    >{#if icon}
      <Icon class="mr-2 align-middle">{icon}</Icon>
    {/if}{link.label}</a
  >
{/each}
